import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Navigate } from 'react-router';

import { So5LeaderboardType } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsLoggedIn } from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import {
  WalletLandingWithBranding,
  walletLandingLoader,
} from '@sorare/gameplay/src/components/landing/WalletLanding/index.tsx';

import social from './assets/social.webp';

const messages = defineMessages({
  metadatasTitle: {
    defaultMessage: 'The Real Fantasy Premier League Game – Sorare Football',
  },
  metadatasDescription: {
    defaultMessage:
      "Collect, play and win officially licensed digital cards featuring players from the Premier League, the world's best football league on Sorare",
  },
});

export const loader = walletLandingLoader('premier-league');

const FootballPage = () => {
  const isLoggedIn = useIsLoggedIn();
  const { generateSportContextPath } = useSportContext();
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();

  useEffect(
    () =>
      setPageMetadata(formatMessage(messages.metadatasTitle), {
        img: social,
        description: formatMessage(messages.metadatasDescription),
      }),
    [setPageMetadata, formatMessage]
  );

  if (isLoggedIn) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_PLAY)} replace />;
  }

  return (
    <WalletLandingWithBranding
      variant="premier-league"
      leaderboards={[
        So5LeaderboardType.IN_SEASON_ENGLAND_LIMITED,
        So5LeaderboardType.IN_SEASON_ENGLAND_UNIQUE,
        So5LeaderboardType.IN_SEASON_ENGLAND_RARE,
      ]}
    />
  );
};

export default FootballPage;
